import { Form, message } from 'antd';
import { useState } from 'react';

import {
  KEY_VERSION,
  SECURITY_MAIL_FORGET_PWD,
  SECURITY_PHONE_FORGET_PWD,
} from '@/constants/api-source-types';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useI18nContext } from '@/i18n/I18n';
import {
  newUserFindPassword,
  newUserFindPasswordValidation,
} from '@/services/retrieve';
import { useStore } from '@/store/useStore';
// import { getGuid } from '@/utils/guid';
import { passwordValidate } from '@/utils/ruleValidate';

import { DefaultTypes, IEmailOrMobile } from './types';

export function useRetrieve(info: any, risk_token: string) {
  const [form] = Form.useForm();
  const [password, setPassword] = useState<string>('');
  const [samePassword, setSamePassword] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [captchaV2Instance, setCaptchaV2Instance] = useState<any>();
  const [cnt, setCnt] = useState<number>(0);
  const [$t] = useI18nContext();
  const { msgError } = useUserInfo();

  const { callVerifyComp } = useStore();

  // 调用人机验证，发送验证码
  const sendVerificationCode = (
    info: IEmailOrMobile,
    successCb: (res: any) => void,
  ) => {
    const fn = (token: string) => {
      const params = {
        // ...captchaData,
        magpie_token: token || '',
        username: info.tapKey === '1' ? info.email : info.mobile,
        country_code: info.tapKey === '2' ? info?.country_code : '',
        cnt: cnt,
        from:
          info.tapKey === '1'
            ? SECURITY_MAIL_FORGET_PWD
            : SECURITY_PHONE_FORGET_PWD,
        key_version: KEY_VERSION,
        risk_token,
        proto_ver: '2.1',
      };
      newUserFindPasswordValidation(params)
        .then((res: any) => {
          setCnt(cnt + 1);
          successCb(res);
        })
        .catch((err: any) => {
          if (err?.ret_code === 31012) {
            message.error($t('accountIncorrect'));
          } else {
            msgError(err);
          }
        });
    };

    if (captchaV2Instance) {
      captchaV2Instance.dealloc();
    }

    setTimeout(() => {
      window.BybitUniFrame.ready(({ captchaV2 }: { captchaV2: any }) => {
        captchaV2.init().then((captchaV2Item: any) => {
          setCaptchaV2Instance(captchaV2Item);
          captchaV2Item;
          const { PARAMS, EVENTNAME } = captchaV2Item.properties;
          const { SUCCESS, ERROR } = captchaV2Item.events;

          captchaV2
            .setProperty(PARAMS, {
              scene: '30001', // 必填，场景码
              lang: 'en', // 非必填，语言，默认读取浏览器语言
              immediate: true, // 非必填，是否立即显示，默认为 false
              txid: '', // 非必填，设备指纹
              login_name: '', // 登陆态必填，非登陆态可选
              country_code: '', // 非必填
            })
            .subscribeEvent(ERROR, (e: any) => {
              window.err = e;
            })
            .subscribeEvent(
              SUCCESS,
              (res: {
                serialNo: string;
                expire_time: string;
                byPass: boolean;
                pass: boolean;
              }) => {
                fn(res?.serialNo);
              },
            );

          captchaV2Item.setProperty(EVENTNAME, 'triggerClick');
        });
      });
    }, 1000);
  };

  // 验证密码可用性
  const validatePassword = (val: DefaultTypes, passwordVal: string) => {
    if (!passwordValidate(passwordVal).allValid) {
      return Promise.reject('');
    } else {
      return Promise.resolve('');
    }
  };

  // 验证确认密码可用性
  const validateSamePassword = (val: DefaultTypes, samePasswordVal: string) => {
    if (!passwordValidate(samePasswordVal).allValid) {
      return Promise.reject('');
    } else {
      if (password && password !== samePasswordVal) {
        return Promise.reject('');
      } else {
        return Promise.resolve('');
      }
    }
  };

  // 判断按钮是否可点击
  const disabledWatch = (allValues: DefaultTypes) => {
    if (
      passwordValidate(allValues['password']).allValid &&
      passwordValidate(allValues['samepassword']).allValid &&
      allValues['password'] === allValues['samepassword']
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  // 输入变化
  const onValuesChange = (
    changeValues: DefaultTypes,
    allValues: DefaultTypes,
  ) => {
    if (changeValues.password) {
      setPassword(changeValues.password);
    }
    if (changeValues.samepassword) {
      setSamePassword(changeValues.samepassword);
    }
    disabledWatch(allValues);
  };

  const changePassword = () => {
    const values = form.getFieldsValue();
    const params: any = {
      password: values.password, // 旧密码
      samepassword: values.samepassword, // 新密码
      username: info.tapKey === '1' ? info.email : info.mobile, // 账户
      risk_token,
      type: info.tapKey === '1' ? 'email' : 'mobile',
      from:
        info.tapKey === '1'
          ? SECURITY_MAIL_FORGET_PWD
          : SECURITY_PHONE_FORGET_PWD,
      proto_ver: '2.1',
    };
    if (info.tapKey === '2') {
      params.country_code = info.country_code || '';
    }
    setLoading(true);
    newUserFindPassword(params)
      .then(() => {
        const type = $t('Password successfully changed, please login again');
        message.success(type);
        setLoading(false);
        window.history.go(-1);
      })
      .catch((error: any) => {
        setLoading(false);
        msgError(error);
      });
  };

  return {
    $t,
    form,
    disabled,
    password,
    samePassword,
    validatePassword,
    validateSamePassword,
    onValuesChange,
    sendVerificationCode,
    loading,
    changePassword,
  };
}
